import { render } from "./StartAggregationModal1.vue?vue&type=template&id=8bedb286&scoped=true"
import script from "./StartAggregationModal1.vue?vue&type=script&lang=js"
export * from "./StartAggregationModal1.vue?vue&type=script&lang=js"

import "./StartAggregationModal1.vue?vue&type=style&index=0&id=8bedb286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bedb286"]])

export default __exports__